// UserAvatar.js (Versión Corregida)
import React, { useState } from 'react';

// Se asume que 'getInitials' está disponible
const getInitials = (name) => {
    // ... tu implementación de getInitials ...
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return parts[0][0].toUpperCase();
};

const UserAvatar = ({ usr_id, usr_name, size = 40 }) => {
    
    const potentialProfileUrl = `https://team.tomi.la/storage/profile`;
    const [imgLoadError, setImgLoadError] = useState(false);

    const shouldShowInitials = imgLoadError || !usr_id;

    const tooltipTitle = usr_name || 'Usuario desconocido'; // Título para el tooltip

    const resolvedSize = Number.isFinite(Number(size)) && Number(size) > 0 ? Number(size) : 40;
    const avatarInlineStyle = { width: `${resolvedSize}px`, height: `${resolvedSize}px` };
    const initialsInlineStyle = {
        ...avatarInlineStyle,
        fontSize: `${Math.max(10, Math.round(resolvedSize * 0.35))}px`,
        lineHeight: 1,
    };

    if (shouldShowInitials) {
        return (
            <div className="avatar-container" title={tooltipTitle}>
                {/* 🎯 CORRECCIÓN: Aplicamos ambas clases al SPAN de iniciales.
                    - 'profile-pic-circle': Define el ancho, alto y border-radius (dimensiones).
                    - 'initials-circle': Define los estilos de texto, fondo y centrado. 
                */}
                <span className="profile-pic-circle initials-circle" style={initialsInlineStyle}> 
                    {usr_name ? getInitials(usr_name) : '...'}
                </span>
            </div>
        );
    }

    // Caso de la imagen
    return (
        <div className="avatar-container" title={tooltipTitle}>
            <img
                src={`${potentialProfileUrl}/${usr_id}.png`}
                alt={`Foto de perfil de ${usr_name}`}
                className="profile-pic-circle" // Solo se aplica aquí para la imagen
                style={avatarInlineStyle}
                onError={() => {
                    setImgLoadError(true); 
                }}
            />
        </div>
    );
};

export default UserAvatar;